import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import GroupPicker from '../picker/GroupPicker'

const GroupsFilter = ({ field, ...props }) => {
  const { t } = useTranslation('listGroups')
  field = field || 'groupIds'
  const label = t('group')
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <div>
      <GroupPicker value={value} onChange={handleChange(field)} multiple label={label} {...props} />
    </div>
  )
}

export default GroupsFilter
